import React, { Component } from 'react';
import PropTypes from 'prop-types';

const Submitting = props =>
  <div className="cart-submitting">
    <div className="cart-submittingWrap">
      <p className="cart-submittingLogo"><span>OctoberTone</span></p>
      <p className="cart-submittingSurtitle">{App.t('cart.please_wait')}</p>
      <p className="cart-submittingTitle">{props.message}</p>
    </div>
  </div>;

Submitting.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Submitting;
